import React, { useState } from 'react';

const SearchBar = ({ searchTerm, onSearchChange }) => {
    const [isListening, setIsListening] = useState(false);

    // Feature detection for SpeechRecognition
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const supportsVoice = !!SpeechRecognition;

    const handleVoiceSearch = () => {
        if (!supportsVoice) {
            alert("Your browser does not support voice search.");
            return;
        }

        if (isListening) return;

        const recognition = new SpeechRecognition();
        recognition.lang = 'en-IN'; // Indian English dialect works well for Indian restaurants
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        recognition.onstart = () => {
            setIsListening(true);
        };

        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            onSearchChange(transcript);
        };

        recognition.onerror = (event) => {
            console.error("Voice search error:", event.error);
            setIsListening(false);
            if (event.error === 'not-allowed') {
                alert("Microphone access was denied. Please check your browser permissions.");
            }
        };

        recognition.onend = () => {
            setIsListening(false);
        };

        try {
            recognition.start();
        } catch (e) {
            console.error("Speech recognition could not start:", e);
            setIsListening(false);
        }
    };

    return (
        <div className="search-bar-container">
            <i className="fas fa-search search-icon"></i>
            <input 
                type="text" 
                id="menu-search-bar" 
                placeholder="Search for dishes..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
            />
            {supportsVoice && (
                <button 
                    className={`voice-search-btn ${isListening ? 'listening' : ''}`}
                    onClick={handleVoiceSearch}
                    title="Search by voice"
                    type="button"
                >
                    <i className="fas fa-microphone"></i>
                </button>
            )}
        </div>
    );
};

export default SearchBar;